export const ARROW_UP = 'ArrowUp';
export const ARROW_DOWN = 'ArrowDown';
export const ENTER = 'Enter';
export const ESCAPE = 'Escape';
